import { ModuleLayout, type ModuleTab } from './ModuleLayout.js';
import { useVisibleTabs } from '../useNavAccess.js';
import './projects-module.css';

export const PROJECTS_TABS: readonly ModuleTab[] = [
  { id: 'overview', hrefSuffix: '', label: 'نمای کلی' },
  { id: 'list', hrefSuffix: '/list', label: 'پروژه‌ها' },
  { id: 'tasks', hrefSuffix: '/tasks', label: 'کارها' },
  { id: 'todos', hrefSuffix: '/todos', label: 'یادداشت‌های شخصی' },
  { id: 'reminders', hrefSuffix: '/reminders', label: 'یادآوری‌ها' },
  { id: 'overdue', hrefSuffix: '/overdue', label: 'موارد عقب‌افتاده' },
  { id: 'comments', hrefSuffix: '/comments', label: 'نظرات' },
  { id: 'assistant', hrefSuffix: '/assistant', label: 'دستیار' },
];

/**
 * Persistent module header + tab strip for Projects — the shared v2
 * `ModuleLayout` (module mark, title, V2Tabs), same as every other module,
 * so `/projects/tasks`, `/projects/todos`, etc. keep a stable «پروژه‌ها و
 * کارها» context and the `[data-module="projects"]` tint.
 */
export function ProjectsModuleLayout() {
  const tabs = useVisibleTabs('projects', PROJECTS_TABS);
  return (
    <ModuleLayout
      moduleId="projects"
      title="پروژه‌ها و کارها"
      subtitle="مدیریت پروژه‌ها، وظایف و پیگیری‌های تیم"
      tabs={tabs}
    />
  );
}
